import type { PatientCommunicationRow } from "../aggregations";
import { formatPatientListLabel } from "../patientLabels";

export interface PatientSendSummary {
  totalSends: number;
  /** Pacientes com pelo menos 1 envio FluxZap. */
  patientsContactedCount: number;
  topPatientLabel: string | null;
  topPatientSendCount: number;
  /** 0–100, uma casa decimal. */
  topPatientSharePercent: number;
}

function roundSharePercent(part: number, total: number): number {
  if (total <= 0) return 0;
  return Math.round((part / total) * 1000) / 10;
}

/** Headline e totais para o foco em pacientes. */
export function buildPatientSendSummary(
  groups: PatientCommunicationRow[],
): PatientSendSummary {
  const totalSends = groups.reduce(
    (sum, group) => sum + group.messages.length,
    0,
  );
  const contacted = groups.filter((g) => g.messages.length > 0);
  const patientsContactedCount = contacted.length;

  const leader = [...contacted].sort(
    (a, b) => b.messages.length - a.messages.length,
  )[0];

  const topSendCount = leader?.messages.length ?? 0;

  return {
    totalSends,
    patientsContactedCount,
    topPatientLabel: leader
      ? formatPatientListLabel(leader.patient)
      : null,
    topPatientSendCount: topSendCount,
    topPatientSharePercent: roundSharePercent(topSendCount, totalSends),
  };
}
